import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class YellowCardDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"CARTON JAUNE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "CARTON JAUNE",
            player: event.detail?.player,
            reason: event.detail?.reason,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    get reason() {
        return this.detail.reason;
    }
    set reason(value) {
        this.detail.reason = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "reason"].includes(key)){
            let commentaire = "Carton jaune"

            const team = getTeam(this.team, match)
            const cardPlayer = getPlayer(this.player, match, team)

            if(this.player){
                if(cardPlayer){
                    commentaire += ' pour '+ cardPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(this.reason){
                switch(this.reason){
                    case 'minorFoul':
                        commentaire+='Raison : Faute mineure.'
                    break
                    case 'unsportingBehavior':
                        commentaire+='Raison : Comportement antisportif.'
                    break
                    case 'dangerousPlay':
                        commentaire+='Raison : Jeu dangereux.'
                    break
                }
            }

            this.text = commentaire
        }
    }
}